import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./App.js";
import "./index.css";

// vite-react-ssg owns the client bootstrap: it prerenders the included routes
// at build time and hydrates them in the browser (and client-renders the SPA
// routes). StrictMode + ErrorBoundary now live in App's RootLayout.
export const createRoot = ViteReactSSG({ routes, basename: import.meta.env.BASE_URL });
